import crypto from 'crypto';

import { Clip } from '../types/clips';

const uniqueClipProps = ['position', 'source_s3_id', 'root_video_id'];

export const limitStringLength = (value: string, limit = 8): string => {
  return value.substring(0, limit);
};

export const getProcessingInfoTrimId = (clip: Clip): string => {
  const trimId = String(clip.processing_information?.trim_id || '');

  return limitStringLength(trimId);
};

export const getTrimRanges = (clip: Clip): string => {
  const result = clip.trimRanges?.reduce((accum, nextTrimRange) => {
    const fromValue = limitStringLength(`${nextTrimRange.from}`);
    const toValue = limitStringLength(`${nextTrimRange.to}`);
    const newTrimRangeString = `${fromValue}-${toValue}`;

    return accum.length ? `${accum}_${newTrimRangeString}` : newTrimRangeString;
  }, '');

  return result ? `_${result}` : '';
};

export const buildHashFromClipData = (clips: Clip[]): string => {
  return clips
    .map(clip => {
      const clipDataString = uniqueClipProps
        .map((key: string) => limitStringLength(String(clip[key] || '')))
        .filter(Boolean)
        .join('_');

      return (
        clipDataString + getProcessingInfoTrimId(clip) + getTrimRanges(clip)
      );
    })
    .join(':');
};

export const getHashForV6Video = (videoId: string, clips: Clip[]): string => {
  return `${limitStringLength(videoId)}#${buildHashFromClipData(clips)}`;
};

export const getMd5Hash = (data: crypto.BinaryLike): string => {
  return crypto.createHash('md5').update(JSON.stringify(data)).digest('hex');
};

export const getHashForVideo = (videoId: string, trimId?: number): string => {
  const videoIdHash = limitStringLength(videoId);
  const trimIdHash = limitStringLength(String(trimId) || '');

  return trimId ? `${videoIdHash}#${trimIdHash}` : videoIdHash;
};
